// extracted by mini-css-extract-plugin
export default {"chart":"chart_chart__Dqawm","chart--overflow":"chart_chart--overflow__Tr-yV"};